import { Form, Grid, Table } from 'semantic-ui-react'
import styled from 'styled-components'

export const FormGroupStyled = styled(Form.Group)`
margin-top: 1em;
margin-left: 0px;
gap: 10px;
flex-direction: column !important; 
 input {
  label {
    font-size: 12px !important;
  }
 }
`
export const StyledTable = styled(Table)`
 th {
  padding: 0.5em 0.4em !important;
 }
 td {
  padding: 3px 0px !important;
 }
`
export const SliderContainer = styled.div`
 label {
  color: black !important;
 }
 margin-bottom: 10px;
`
export const StyledGridColumn = styled(Grid.Column)`
 min-width: 260px !important;
`